import { boxShadow, colorsNew, gtSmMediaQuery, ltGtMediaQuery, xsMediaQuery } from 'root/src/client/web/commonStyles';
export const HeroSectionStyle = {
    heroSectionContainer: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        justifyContent: 'space-evenly',
        margin: [[50, 'auto']],
        '@media (max-width: 1150px)': {
            flexDirection: 'column',
            alignItems: 'center',
            minHeight: '100vh',
        },
        [gtSmMediaQuery]: {
            margin: [[0, 'auto', 50, 'auto']],
        },
    },
    gameSection: {
        width: '60%',
        marginRight: '5%',
        [ltGtMediaQuery]: {
            margin: [[0, 'auto', 50]],
            width: '100%',
        },
    },
    gameInfo: {
        display: 'flex',
        justifyContent: 'space-between',
        [ltGtMediaQuery]: {
            flexDirection: 'column',
        },
    },
    gameDescription: {
        width: '70%',
        [ltGtMediaQuery]: {
            width: '100%',
        },
    },
    subHeadingContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        margin: [[5, 'auto']],
    },
    tags: {
        display: 'flex',
        flexDirection: 'column',
        width: '22%',
        textAlign: 'end',
        justifyContent: 'flex-start',
        gap: 8,
        [ltGtMediaQuery]: {
            flexDirection: 'row',
            justifyContent: 'space-around',
            textAlign: 'center',
            width: '100%',
            margin: [[10, 'auto']],
        },
    },
    tagGroup: {
        display: 'flex',
        justifyContent: 'flex-end',
        flexWrap: 'wrap',
        gap: 3,
        marginTop: 3,
        [ltGtMediaQuery]: {
            justifyContent: 'center',
        },
    },
    platformIcon: {
        margin: [[0, 3]],
    },
    pile: {
        padding: [[2, 6]],
        borderRadius: 4,
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        border: 0,
        outline: 0,
        background: colorsNew.dark1,
    },
    media: {
        width: '100%',
        marginTop: 15,
    },
    playerArea: {
        position: 'relative',
        minHeight: 500,
    },
    playerImage: {
        display: 'flex',
        flexDirection: 'column',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        transition: 'all .3s',
        '& > *': {
            maxHeight: '100%',
            maxWidth: '100%',
            objectFit: 'contain',
        },
    },
    thumbnails: {
        width: '100%',
        overflowX: 'auto',
        padding: [[15, 0]],
        display: 'flex',
        marginTop: 15,
        gap: 10,
        '&::-webkit-scrollbar': {
            height: 13,
        },
        '&::-webkit-scrollbar-track': {
            borderRadius: 3,
            background: colorsNew.dark2,
        },
        '&::-webkit-scrollbar-thumb': {
            borderRadius: 3,
            background: colorsNew.secondary,
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: colorsNew.primary,
        },
        [ltGtMediaQuery]: {
            overflow: 'auto',
            gap: 0,
        },
    },
    thumbnailContainer: {
        position: 'relative',
        cursor: 'pointer',
        borderRadius: 5,
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        flexShrink: 0,
        '&:first-child': {
            marginLeft: 8,
        },
        '&:last-child': {
            marginRight: 8,
        },
        '& *': {
            objectFit: 'cover',
            width: 118,
            height: 65,
        },
        [ltGtMediaQuery]: {
            margin: 8,
        },
        [gtSmMediaQuery]: {
            position: 'relative',
            zIndex: 1,
        },
    },
    activeThumbnail: {
        boxShadow: boxShadow(colorsNew.primary),
    },
    playIconWrapper: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        cursor: 'pointer',
        backgroundColor: 'rgba(0,0,0,0.3)',
        [ltGtMediaQuery]: {
            top: 'auto',
            left: 'auto',
            transform: 'translate(0%,0%)',
        },
    },
    daresSliderSection: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    availableInfo: {
        display: 'flex',
        width: 420,
        marginBottom: 10,
        [xsMediaQuery]: {
            width: 300,
        },
    },
    progresBarWrapper: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        width: 420,
        [xsMediaQuery]: {
            width: 300,
        },
    },
    availableKeys: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flex: 2,
        height: 16,
        backgroundColor: 'white',
        borderRadius: 15,
    },
    percentage: {
        height: 13,
        borderRadius: 15,
        margin: [[0, 3]],
    },
    helperContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 10,
        [xsMediaQuery]: {
            width: 300,
        },
    },
    helperText: {
        width: 270,
        fontSize: 12,
        fontFamily: 'Roboto mono',
        fontWeight: 700,
        color: colorsNew.light3,
    },
    helperAction: {
        height: '100%',
        marginRight: 10,
    },
    helperActionButton: {
        fontSize: 24,
        width: 120,
    },
    remainingPrizes: {
        marginBottom: 10,
    },
    horizontalLine: {
        width: 420,
        height: 0.5,
        backgroundColor: colorsNew.light3,
        margin: [[20, 0, 10, 0]],
        [xsMediaQuery]: {
            width: 300,
        },
    },
    rewardButton: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        maxWidth: 220,
    },
    sponsorshipContainer: {
        margin: [[10, 0, 10, 0]],
    },
};
